import {
  PRODUCT_TYPE_LABOUR_PRODUCT_LABEL,
  PRODUCT_TYPE_PRODUCT_KIT_LABEL,
} from "@/utils/constants";

/**
 * Checks whether a product kit contains any labour items in its productKitItems or sub-kits.
 * @param {Object} item - A product kit order item with productKitItems and subKits arrays.
 * @returns {boolean} True if any kit item or sub-kit product is a labour product.
 */
const hasLabourInKit = (item) => {
  const kitHasLabour =
    Array.isArray(item.productKitItems) &&
    item.productKitItems.some((k) => k.productType === PRODUCT_TYPE_LABOUR_PRODUCT_LABEL);

  const subKitsHaveLabour =
    Array.isArray(item.subKits) &&
    item.subKits.some(
      (subKit) =>
        Array.isArray(subKit.kitProducts) &&
        subKit.kitProducts.some((k) => k.productType === PRODUCT_TYPE_LABOUR_PRODUCT_LABEL)
    );

  return kitHasLabour || subKitsHaveLabour;
};

/**
 * Filters order items to only those relevant to labour:
 * - Direct labour line items
 * - Product kits that contain labour items in their productKitItems and subKits
 */
export const getLabourLineItems = (items) =>
  items.filter((p) => {
    if (p.productType === PRODUCT_TYPE_LABOUR_PRODUCT_LABEL) {
      return true;
    }
    if (p.productType === PRODUCT_TYPE_PRODUCT_KIT_LABEL) {
      return hasLabourInKit(p);
    }
    return false;
  });
